var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-record dashboard" },
    [
      _vm.isTenant && _vm.loading
        ? _c("h6", { staticClass: "font-dark-gray" }, [
            _c("i", { staticClass: "rotation fa fa-refresh" }),
            _vm._v("\n    " + _vm._s(_vm.$t("loading")) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !(_vm.isTenant && _vm.loading) &&
                (_vm.workPermits.length || _vm.showCreateStandaloneBtn),
              expression:
                "!(isTenant && loading) && (workPermits.length || showCreateStandaloneBtn)",
            },
          ],
        },
        [
          _c("h4", { staticClass: "title-container" }, [
            _c("div", { class: [_vm.isTenant ? "workPermit_title" : ""] }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("workPermit.title")) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.showCreateStandaloneBtn
              ? _c("div", { staticClass: "btn-container" }, [
                  _c("div", { staticClass: "hints" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "termsAndConditions." +
                              _vm.regionName +
                              ".workPermit.hintForEdinburghTower",
                            [_vm.$t("workPermit.types.WORK"), 5]
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "termsAndConditions." +
                              _vm.regionName +
                              ".workPermit.hintForOthers",
                            [_vm.$t("workPermit.types.WORK"), 3]
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn--orange",
                      on: {
                        click: function () {
                          return _vm.applySAWorkPermit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("standaloneWorkPermits.applySAWorkPermit")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__table" }, [
            _c("table", { staticClass: "sort_table" }, [
              _c("thead", [
                _c(
                  "tr",
                  { staticClass: "dashboard__table--header" },
                  _vm._l(_vm.tableHeaders, function (header) {
                    return _c(
                      "th",
                      {
                        key: header.name,
                        class: header.className,
                        on: {
                          click: function ($event) {
                            return _vm.sortBy(header.attrPath)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(header.name) +
                              "\n                "
                          ),
                          _vm.sortingAttr === header.attrPath
                            ? _c("i", {
                                class: [
                                  _vm.reverse ? "triangle-down" : "triangle-up",
                                ],
                              })
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sortedRecords, function (item) {
                  return _c(
                    "tr",
                    { key: item.id, staticClass: "dashboard__table--body" },
                    [
                      _c("td", { staticClass: "permitNo" }, [
                        _c(
                          "a",
                          {
                            staticClass: "link_text",
                            on: {
                              click: function ($event) {
                                return _vm.navToPage(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.code) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.contractorName) +
                            "\n              " +
                            _vm._s(_vm.getCompanyName(item)) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.projectType))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "search-filter-wptype" }, [
                        _c("span", [_vm._v(_vm._s(item.type))]),
                        _vm._v(" "),
                        item.hasHotWork
                          ? _c("img", {
                              attrs: { src: "/ic_hotwork.png", alt: "hotwork" },
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.building))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.floorsVal))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.location))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("customStatusLabel")(
                              _vm.maskStatusForExternalUser(item.status)
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "duration-text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.duration) +
                            "\n            "
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("SAWorkPermitTnC", {
        ref: "saWpTnCModal",
        attrs: {
          okBtnAction: "accept",
          companyName: _vm.selectedTrCompanyName,
        },
        on: { onOkClick: _vm.confirmCreateStandaloneWp },
      }),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "selectTRModal",
          attrs: { size: "medium", okBtnAction: "confirm" },
          on: {
            onCloseClick: function () {
              return _vm.beforeCloseSelectTRModal()
            },
            onOkClick: function () {
              return _vm.selectTRModalConfirm()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-pure-text",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("standaloneWorkPermits.selectTenancyRecord")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("HKLSelect", {
                class: _vm.errHighlight,
                attrs: {
                  value: _vm.selectedTradeNameKey,
                  options: _vm.tradeNameHklOptions,
                  showSearch: true,
                  placeholder: _vm.$t("directory.label.tenantName"),
                },
                on: { change: _vm.onTradeNameChange },
              }),
              _vm._v(" "),
              _c("HKLSelect", {
                class: _vm.errHighlight,
                attrs: {
                  value: _vm.selectedBuilding || undefined,
                  options: _vm.buildingHklOptions,
                  showSearch: true,
                  placeholder: _vm.$t("directory.label.building"),
                },
                on: { change: _vm.onBuildingChange },
              }),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.selectedTradeNameSummary))]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }